import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import { toast } from "react-toastify";
import Map from "react-map-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import SectionTitle from "../../components/SectionTitle";
import { BsTelephoneFill } from "react-icons/bs";
/* eslint-disable import/no-webpack-loader-syntax */
import mapboxgl from "mapbox-gl";
import SocialLinks from "../../components/reusable/SocialLinks";
import { MdEmail } from "react-icons/md";
import WithHelmet from "../../utils/WithHelmet";
// @ts-ignore
mapboxgl.workerClass =
  require("worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker").default;

// meta tags
const pageTitle = " Contact | Md Shahar Shitol";
const description =
  "Get in touch with Md Shahar Shitol for any inquiries, collaborations, or project opportunities. Fill out the contact form or reach out through the provided contact details. We look forward to hearing from you!";
const keywords = [
  "contact",
  "collaboration",
  "project opportunities",
  "inquiries",
  "get in touch",
  "md shahar shitol",
  "frontend developer",
  "hire me",
];
const Contact = () => {
  const [setting] = useState({
    scrollZoom: true,
    boxZoom: true,
    dragRotate: true,
    dragPan: true,
    keyboard: true,
    doubleClickZoom: true,
    touchZoomRotate: true,
    touchPitch: true,
    minZoom: 0,
    maxZoom: 20,
    minPitch: 0,
    maxPitch: 85,
  });
  const sendEmail = (e) => {
    e.preventDefault();
    if (
      e.target.from_name.value ||
      e.target.from_email.value ||
      e.target.message.value
    ) {
      emailjs
        .sendForm(
          "service_zn2mopb",
          "template_13008us",
          e.target,
          "qreSIMC3uAem9Kxox"
        )
        .then(
          (result) => {
            e.target.reset();
            if (result.text === "OK") {
              toast.success("Email Sent!");
            }
          },
          (error) => {
            toast.error("Couldn't Sent!");
          }
        );
    } else {
      toast.error("Put");
    }
  };
  return (
    <div
      className="p-3 py-10 md:py-0 md:px-10 mb-20 md:mb-5"
      data-aos="fade-right"
      data-aos-offset="200"
      data-aos-delay="50"
      data-aos-duration="700"
      data-aos-easing="ease-in-out"
    >
      <SectionTitle>Contact</SectionTitle>
      <h1 className="text-3xl font-bold">Get in Touch</h1>
      <div className="mt-10 capitalize">
        <Map
          mapboxAccessToken="pk.eyJ1IjoibWRzYWhhcnNoaXRhbCIsImEiOiJjbDQ3aTJyNnQwMno5M2RvaG5vcnNhYmlxIn0.q3pRLVwAb6gwtz3vMT-lZQ"
          initialViewState={{
            longitude: 90.40841,
            latitude: 23.780625,
            zoom: 13,
            bearing: 0,
            pitch: 60,
          }}
          {...setting}
          mapStyle="mapbox://styles/mapbox/dark-v9"
          style={{ height: 300 }}
        />
        <div className="md:flex justify-center items-center gap-10">
          <div className="flex-1">
            <h1 className="text-2xl md:text-4xl font-bold text-center md:text-left my-4">
              Get in touch - let's <span className="text-accent">work</span>{" "}
              together!
            </h1>

            <div className="my-6">
              <p className="flex items-center justify-center md:justify-start my-2">
                <span className="font-bold mr-4">
                  <BsTelephoneFill />
                </span>{" "}
                <a href="tel:+8801642413652">+8801642413652</a>
              </p>{" "}
              <a
                href="mailto:mdsaharshitol@gmail.com"
                className="flex items-center justify-center md:justify-start text-xl"
                target="_blank"
                rel="noopener noreferrer"
              >
                <MdEmail />{" "}
                <span className="ml-4 text-base lowercase">
                  mdsaharshitol@gmail.com
                </span>
              </a>
            </div>
            <div className="text-center md:text-left mt-4 mb-6">
              <span className="font-bold">Address:</span>
              <p>Islampur Madrasha Road,</p>
              <p>Dhamrai, Dhaka - 1350</p>
              <p>Bangladesh</p>
            </div>
            <div className="flex justify-center md:justify-start">
              <SocialLinks />
            </div>
          </div>
          <form onSubmit={sendEmail} className="w-full mb-9 flex-1">
            <div className="w-full mt-20">
              <div className="w-full my-8">
                <input
                  name="from_name"
                  type="text"
                  placeholder="Your Name"
                  className="input input-bordered w-full rounded-none"
                  required
                />
              </div>
              <div className="w-full my-8">
                <input
                  name="from_email"
                  type="text"
                  placeholder="Your Email"
                  className="input input-bordered w-full rounded-none"
                  required
                />
              </div>
              <div className="w-full mt-8">
                <textarea
                  name="message"
                  className="textarea textarea-bordered w-full rounded-none h-[120px]"
                  placeholder="Send your message"
                  required
                ></textarea>
              </div>
            </div>
            <input
              type="submit"
              value="Send Message"
              className="btn rounded-none border-none bg-accent text-primary hover:bg-accent/90"
            />
          </form>
        </div>
      </div>
    </div>
  );
};

// export default Contact;
export default WithHelmet(Contact, pageTitle, description, keywords);
